import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FileText, Briefcase, ShieldCheck, LogOut } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { LOGO_URL } from "@/lib/siteData";

const LINKS = [
  { to: "/admin", label: "Articles", icon: FileText, id: "articles" },
  { to: "/admin/affaires", label: "Affaires", icon: Briefcase, id: "deals" },
  { to: "/admin/consentements", label: "Consentements", icon: ShieldCheck, id: "consents" },
];

export const notifyDealsChanged = () => window.dispatchEvent(new Event("deals-changed"));

export default function AdminHeader() {
  const { authFetch, logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [due, setDue] = useState(0);

  useEffect(() => {
    const load = () => authFetch("/admin/deals/summary").then((r) => r.json()).then((d) => setDue(d.due_count || 0)).catch(() => {});
    load();
    window.addEventListener("deals-changed", load);
    return () => window.removeEventListener("deals-changed", load);
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <header className="bg-white border-b border-md-border sticky top-0 z-20">
      <div className="max-w-6xl mx-auto px-6 py-3 flex flex-wrap items-center justify-between gap-3">
        <Link to="/admin" className="flex items-center gap-3">
          <img src={LOGO_URL} alt="MD" className="h-10 object-contain" />
          <div className="text-xs uppercase tracking-widest text-md-accent font-bold border-l border-md-border pl-3">Espace admin</div>
        </Link>
        <nav className="flex items-center gap-1">
          {LINKS.map(({ to, label, icon: I, id }) => {
            const active = pathname === to || (to !== "/admin" && pathname.startsWith(to)) || (id === "articles" && pathname.startsWith("/admin/articles"));
            return (
              <Link key={to} to={to} data-testid={`admin-nav-${id}`} className={`relative inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full text-sm font-medium transition-colors ${active ? "bg-md-primary text-white" : "text-md-muted hover:text-md-primary hover:bg-md-bg"}`}>
                <I className="w-4 h-4" /> {label}
                {id === "deals" && due > 0 && (
                  <span data-testid="admin-followups-badge" className="ml-1 min-w-[20px] h-5 px-1.5 rounded-full bg-md-secondary text-white text-[11px] font-bold grid place-items-center">{due}</span>
                )}
              </Link>
            );
          })}
        </nav>
        <div className="flex items-center gap-4">
          <Link to="/" className="text-sm text-md-muted hover:text-md-primary">Voir le site →</Link>
          <button data-testid="admin-logout" onClick={() => { logout(); navigate("/admin/login"); }} className="inline-flex items-center gap-1.5 text-sm text-md-muted hover:text-md-primary">
            <LogOut className="w-4 h-4" /> Déconnexion
          </button>
        </div>
      </div>
    </header>
  );
}
